module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/tutorials-examples-fetch.json
// module id = 816
// module chunks = 51155237536967